if (!customElements.get('product-vendor')) {
  customElements.define(
    'product-vendor',
    class ProductVendor extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}
